import appConfig from '../config/appConfig';

export const SUPPORTED_API_VERSIONS = ['20260101', '20260507'];

const docsBaseUrl = () => `${appConfig.docsBaseUrl}/docs`;

export const getApiVersionDocsUrl = (version) => {
  if (!version || version.length !== 8) {
    return `${docsBaseUrl()}/2026-01-01/api-versioning/overview`;
  }

  const docSegment = `${version.slice(0, 4)}-${version.slice(4, 6)}-${version.slice(6, 8)}`;
  return `${docsBaseUrl()}/${docSegment}/api-versioning/overview`;
};
